// @flow

import gql from 'graphql-tag';

import { partialWithDefault } from 'app/common/CommonUtils';

import type { FolderType, TeamId } from 'app/dashboard/types';

export const isSharedWithGroup = (teamId: TeamId, folder: FolderType) => {
  return (folder.teams || []).some(g => g.id === teamId);
};

export const ALL_GROUP = 'all';
export const isSharedWithAll = partialWithDefault(
  isSharedWithGroup,
  [ALL_GROUP],
  false
);

export const isSharedWithMember = (memberId: string, folder: FolderType) => {
  return (folder.members || []).some(m => m.id === memberId);
};

// Shared query necessary for updating cache
export const fullFoldersQuery = gql`
  query DashboardZapsFolders($accountId: Int!) {
    folders(accountId: $accountId) {
      accountId
      id
      isShared
      members {
        email
        id
        imageUrl
        isOwner
        name
      }
      ownerId
      teams {
        id
        imageUrl
        memberCount
        name
      }
      title
    }
  }
`;
